import { generateWorkoutPosts } from "../mock/workoutPosts";

// Generated once per session so pagination is stable across refetches.
const ALL_POSTS = generateWorkoutPosts(48);
const PAGE_SIZE = 6;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Cursor-paginated feed fetch. Mirrors the real contract this will call
 * once a backend exists: `GET /api/feed?cursor=&limit=`.
 *
 * To swap in the real backend later, replace this function body with:
 *   const { data } = await api.get("/feed", { params: { cursor: pageParam, limit } });
 *   return data;
 * — nothing in useWorkoutFeed.js or WorkoutFeed.jsx needs to change.
 */
export async function fetchWorkoutFeed({ pageParam = 0, limit = PAGE_SIZE } = {}) {
  await delay(450 + Math.random() * 300);
  const start = pageParam;
  const end = start + limit;
  const posts = ALL_POSTS.slice(start, end);
  const nextCursor = end < ALL_POSTS.length ? end : undefined;
  return { posts, nextCursor };
}

// Exposed so social.js mutations (like/save) can patch the underlying
// in-memory store without a second copy of the data.
export function getPostById(id) {
  return ALL_POSTS.find((p) => p.id === id);
}
